@if (userAvatar && accountMenuItems) {
  <ng-template #userAvatarTemplate>
    <p-avatar data-id="user-avatar" [bdAvatar]="userAvatar" />
  </ng-template>
  <p-button
    *transloco="let t; scope: 'uiComponents'"
    data-id="account-menu-button"
    [attr.aria-label]="t('uiComponents.collaboration.accountMenuButtonInfo')"
    icon="{{
      expandIcon ? 'ui-down bd-button-chevron' : 'ui-up bd-button-chevron'
    }}"
    [text]="true"
    styleClass="bd-toolbar-button bd-account-menu-button bd-round-right mx-1 {{
      isFirstToolbarItem ? 'bd-round-left' : ''
    }}"
    [pTooltip]="t('uiComponents.collaboration.accountMenuButtonInfo')"
    tooltipPosition="bottom"
    [showDelay]="500"
    (onClick)="
      accountMenu.toggle($event); onMenuButtonClick(accountMenu.visible)
    "
  >
    <ng-template [ngTemplateOutlet]="userAvatarTemplate"></ng-template>
  </p-button>
  <p-menu
    #accountMenu
    data-id="account-menu"
    [appendTo]="appendTo"
    styleClass="bd-toolbar-menu bd-account-menu-popup"
    [model]="(accountMenuItems | translateMenuItems | async) ?? []"
    [popup]="true"
    appendTo="body"
    (onHide)="changeIcon(true)"
    (onShow)="changeIcon(false)"
  >
    <ng-template #item let-item>
      @if (item.id === 'userAccountMenuItem') {
        <div class="bd-user-item">
          <bd-user-card
            data-id="user-account-menu-item"
            [bdAvatar]="userAvatar"
          ></bd-user-card>
        </div>
      } @else {
        <a
          [attr.data-id]="'account-menu-item-' + (item.id ?? item.labelKey)"
          class="p-menu-item-link flex items-center"
          [id]="item.id"
        >
          @if (item.icon) {
            <i [class]="item.icon"></i>
          }
          <span class="p-menu-item-label">
            {{ item.label }}
          </span>
        </a>
      }
    </ng-template>
  </p-menu>
}
